import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", null, "基本料金のお支払い", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("dl", { style: { "text-align": "center" } }, [
    /*#__PURE__*/ _createTextVNode(" ①"),
    /*#__PURE__*/ _createElementVNode("b", null, "クレジットカード登録"),
    /*#__PURE__*/ _createTextVNode("をしてから"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" ②"),
    /*#__PURE__*/ _createElementVNode("b", null, "基本料金決済"),
    /*#__PURE__*/ _createTextVNode("を行ってください。 ")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { style: { "text-align": "center" } }, " ↓ ", -1);
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'require_payment',
    props: {
        common: null
    },
    setup(__props) {
        const props = __props;
        const onClickPaymentCard = () => {
            Inertia.get(route('payment.show'));
        };
        const onClickPlan = () => {
            Inertia.get(route('plan.show'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        id: "all_wrapper",
                        class: "payment_entry"
                    }, [
                        _createElementVNode("div", { class: "wrapper_1" }, [
                            _hoisted_2,
                            _createElementVNode("div", { class: "inner" }, [
                                _createElementVNode("form", null, [
                                    _hoisted_3,
                                    _createElementVNode("div", { style: { "text-align": "center" } }, [
                                        _createElementVNode("a", {
                                            onClick: onClickPaymentCard,
                                            style: { "cursor": "pointer" }
                                        }, "①クレジットカード登録")
                                    ]),
                                    _hoisted_4,
                                    _createElementVNode("div", { style: { "text-align": "center" } }, [
                                        _createElementVNode("a", {
                                            onClick: onClickPlan,
                                            style: { "cursor": "pointer" }
                                        }, "②基本料金決済")
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
